// 腾达优采
export default {
    nav: [
        {
            title: '首页',
            href: '/',
            activeReg: /(^\/search*)|(^\/$)/,
        },
        {
            title: '新闻公告',
            href: '/news',
            activeReg: /(^\/news*)/,
        },
        {
            title: '交易信息',
            href: '/business',
            activeReg: /(^\/business*)/,
        },
        {
            title: '帮助中心',
            href: '/guide',
            activeReg: /(^\/guide*)/,
        },
        {
            title: '下载中心',
            href: '/download',
            activeReg: /(^\/download*)/,
        },
       
        {
            title: 'CA办理/续费',
            href: '/cahandle',
            activeReg: /(^\/cahandle*)/,
        },
        {
            title: '关于我们',
            href: '/about',
            activeReg: /(^\/about*)/,
        },
    ],
    head: {
        title: '腾达优采电子采购交易平台',//全称
        title2: '腾达优采',//简称
        jc_title: '腾达优采',//简称
        citycode:'',//城市编号
        planName:'tdyc',
        caType:'',
        caHref:'',//CA申请链接
        meta: {
            description: '腾达优采电子采购交易平台,交易平台,招投标,电子交易平台',
            keywords: '腾达优采电子采购交易平台,交易平台,招投标,电子交易平台',
        },
        favicon: '/tdyc/favicon.ico',
        logoUrl: '/tdyc/images/logo.png',//首页LOGO
        loginImgUrl: '/tdyc/images/loginImg.png',
        registerImg: '',//注册页面LOGO
        bannerList:[
            {
                linkimg:'',
                linkurl:''
            }
        ],
        tbLoginUrl:'http://tb.huizezhao.cn/#/login?plan=tdyc',
        // 用户角色登录
        userRoles: [
            {
                imgsrc: '/img/hzzlogin/tb.png',
                href: 'http://tb.huizezhao.cn/#/login?plan=tdyc',
                title: '投标人登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/zb.png',
                href: 'http://dl.huizezhao.cn/otc/#/login?plan=tdyc&mRole=agent',
                title: '招标代理登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/cg.png',
                href: 'http://dl.huizezhao.cn/otc/#/login?plan=tdyc&mRole=tender',
                title: '采购人登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/pb.png',
                href: 'http://pb.huizezhao.cn/?plan=tdyc',
                title: '评标登录',
                class: ''
            },
        ],
        userRolesZfcg:[
            {
                imgsrc: '/img/hzzlogin/tb.png',
                href: 'http://tb.huizezhao.cn/#/login?plan=tdyc',
                title: '投标人登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/zb.png',
                href: 'http://dl.huizezhao.cn/otc/#/login?plan=tdyc&mRole=agent',
                subHref: 'http://zfcgdl.huizezhao.cn/otc/#/login?plan=tdyc&mRole=agent',
                title: '招标代理登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/cg.png',
                href: 'http://zfcgdl.huizezhao.cn/otc/#/login?plan=tdyc&mRole=tender',
                title: '采购人登录',
            },
            {
                imgsrc: '/img/hzzlogin/pb.png',
                href: 'http://pb.huizezhao.cn/?plan=tdyc',
                title: '评标登录',
            }
        ],
        friendLinks:[
            {
                href: 'http://www.cebpubservice.com/',
                title: '中国招投标公共服务平台'
            },
            {
                href: 'http://www.ccgp.gov.cn/',
                title: '中国政府采购网'
            },
            {
                href: 'https://www.creditchina.gov.cn/',
                title: '信用中国'
            },
            {
                href: 'https://wenshu.court.gov.cn/',
                title: '中国裁判文书网'
            },
            {
                href: '',
                title: ''
            },
        ],
        tel: '400-780-9998', //客服电话
        tel2: '',//备用电话/其他电话
        fax: '',//传真号码
        email: 'hb@zhbykj.com', //邮箱地址
        workTime: '',//工作时间
        postalCode: '',//邮政编码
        companyName: '河北中惠博裕科技有限公司',  //运营公司名称
        companyAddress: '河北省石家庄市桥西区中山东路126号凯嘉大厦10楼',//公司地址
        companyLatLng:{ lng: 0, lat: 0 },//公司地址坐标
        showWeather: false,//是否显示天气
        icp:'冀ICP备14012003号-14',
        gwIcp:'',
        products: [
            {
                title: 'xxxx',
                href: 'xxxxx'
            },
        ],
        isCheckOtherSingleCertCode: true, //注册页面 是否校验 其他一证一照代码
    },
    proxy: {
        '/web': {
            target: 'https://www.huizezhao.cn/',
            changeOrigin:true,
        },
    },
}